export const InitialValues = {
  stationID: "",
  name: "",
  serialNumber: "",
  model: "",
  address: "",
  address_line1: "",
  address_line2: "",
  country: "",
  state: "",
  city: "",
  zipCode: "",
  vendorName: "",
  firmwareVersion: "",
  modem: {
    iccid: "",
    imsi: "",
  },
  timeZone: "",
  coordinates: {
    latitude: "",
    longitude: "",
  },
  // availabilityStartTime: null,
  // availabilityEndTime: null,
  adminStatus: "",
  OCPPVersion: "",
  hosts: [],
};
